export default __webpack_public_path__ + "static/media/salam-odb-logo.ba5f32de.svg";